import { globalPut } from "../index";

// PUT /users/login-suspension (back/utils/loginSuspension): pause or restore
// sign-in for several people at once. Answers per person -
// { done, unchanged, refused, results: [{ userId, status, reason, loginSuspended }] }.
export const setLoginSuspension = (userIds, suspended) =>
  globalPut("/users/login-suspension", { userIds, suspended });
